import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import RootReducer from './rootReducer';
import AzureMonitoring from '../screens/Insight/Azure';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const Store = createStore(RootReducer, composeEnhancers(applyMiddleware(AzureMonitoring, thunk)));

export default Store;
